import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { User } from '../../models/user.model';

export interface SessionState {
  loading: boolean;
  token: string;
  user: User;
}

export function createSessionInitialState(): SessionState {
  return {
    loading: false,
    token: null,
    user: null
  };
}

@StoreConfig({ name: 'session' })
@Injectable()
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createSessionInitialState());
  }
}
